import { useLayoutEffect } from "react";

interface TProps {
    action: (ev: KeyboardEvent) => void;
    type: "keydown" | "keypress" | "keyup";
    touchToBind: string[];
}

/**
 * Hook React to bind keyboard touch with action in component or view.
 * Hook automaticly remove event when action refresh.
 * Event are not fire while focus are on focusable element like input.
 * @param action Action to bind on key (useCallBack recommended)
 * @param type Type of the event : "keydown" | "keypress" | "keyup"
 * @param touchToBind String array of keyboard's code
 */
const useBindingKeyboard = ({ action, type, touchToBind }: TProps) => {
    const elementFocusables: string[] = ["INPUT", "TEXTAREA", "SELECT"];

    const bindActionToTouch = (ev: KeyboardEvent) => {
        if (touchToBind.indexOf(ev.code) > -1) {
            if (
                elementFocusables.indexOf(document.activeElement?.nodeName ?? "") === -1 &&
                !document.activeElement?.className.includes("ContentEditable__root")
            ) {
                ev.preventDefault();
                action(ev);
            }
        }
    };

    useLayoutEffect(() => {
        document.addEventListener(type, bindActionToTouch);
        return () => {
            document.removeEventListener(type, bindActionToTouch);
        };
    }, [action, type]);
};

export default useBindingKeyboard;
